function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.162,0H12.056c-1.657,0-3,1.343-3,3v7.718H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6.056v12.104H3 c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6.056v12.104H3c-1.657,0-3,1.344-3,3s1.343,3,3,3h6.056V65.03H3c-1.657,0-3,1.344-3,3 c0,1.657,1.343,3,3,3h6.056v12.105H3c-1.657,0-3,1.343-3,3c0,1.656,1.343,3,3,3h6.056V97c0,1.656,1.343,3,3,3h75.105 c1.656,0,3-1.344,3-3V3C90.162,1.343,88.818,0,87.162,0 M84.162,94H15.056v-4.865h5.947c1.657,0,3-1.344,3-3c0-1.657-1.343-3-3-3 h-5.947V71.03h5.947c1.657,0,3-1.343,3-3c0-1.656-1.343-3-3-3h-5.947V52.926h5.947c1.657,0,3-1.344,3-3s-1.343-3-3-3h-5.947V34.822 h5.947c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-5.947V16.718h5.947c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-5.947V6h69.105V94z"
});

var SvgAdempimenti = function SvgAdempimenti(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 92,
    height: 101,
    viewBox: "-0.987 -0.668 92 101",
    enableBackground: "new -0.987 -0.668 92 101",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdempimenti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adempimenti.22cc26f0.svg";
export { ForwardRef as ReactComponent };